import React from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import { KTSVG } from '_metronic/helpers'

interface Props {
	open: boolean
	image: File | null
	isSubmitting: boolean
	onChange: (value: any) => void
	onClose: () => void
	onConfirm: () => void
}

const GalleryImageForm: React.FC<Props> = ({
	image,
	onChange,
	onClose,
	onConfirm,
	open,
	isSubmitting,
}) => {
	const modalsRoot = document.getElementById('root-modals') || document.body

	return createPortal(
		<Modal
			size="sm"
			id="kt_modal_supplier_location_selection_modal"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-fullscreen-lg-down modal-xl modal-dialog modal-dialog-centered"
			show={open}
			onHide={onClose}
			backdrop={true}>
			<div className="modal-content">
				<div className="modal-body py-lg-10 px-lg-10 min-h-500px">
					<h1 className="text-kumopack-grey-900 text-center">เพิ่มรูปภาพ Gallery</h1>
					{/* <div className="text-kumupack-grey-600 text-center">
                            ทุกความคิดเห็นของท่านมีผลต่อการปรับปรุงระบบให้ดีิยิ่งขึ้น
                        </div> */}

					<div className="separator my-5"></div>

					<div className="w-100 h-500px">
						<div
							className="w-100 rounded bg-kumopack-base-white border mb-5 text-center shadow d-flex align-items-center justify-content-center position-relative"
							style={{ height: '320px' }}>
							{image && (
								<div
									className="btn btn-sm btn-icon btn-danger btn-active-light-danger position-absolute"
									style={{ top: -10, right: -10 }}
									onClick={() => onChange(null)}>
									<KTSVG className="svg-icon-1" path="/media/icons/duotune/general/gen027.svg" />
								</div>
							)}
							{image && (
								<img
									className="mx-auto w-100 h-100 rounded"
									src={typeof image !== 'string' ? URL.createObjectURL(image as any) : image}
									onError={(e: any) => {
										e.target.onerror = null
										e.target.src = '/media/icons/kumopack/default-placeholder.png'
									}}
									style={{ userSelect: 'none', pointerEvents: 'none', objectFit: 'contain' }}
									alt="Factory Cover"
								/>
							)}
							{!image && (
								<div className="fw-bold fs-5 text-kumopack-grey-300 py-10">No Files Uploaded</div>
							)}
						</div>

						<FormGenerator
							formKey="supplier-add-form-drag-and-drop-cover-photo"
							inputType="drag-and-drop"
							multiple={false}
							accept="image/*"
							onFileUpload={coverFiles => {
								onChange(coverFiles[0])
							}}
						/>
					</div>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-sm btn-kumopack-grey-300 text-kumopack-grey-600"
						onClick={onClose}>
						ยกเลิก
					</button>

					<button
						type="button"
						className="btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white"
						onClick={onConfirm}
						disabled={isSubmitting}>
						ยืนยัน
					</button>
				</div>
			</div>
		</Modal>,
		modalsRoot
	)
}

export default GalleryImageForm
